<template>
  <div class="difficulty">
    <img src="./assets/farewell.png"/>
  </div>
</template>
<script>
import configFn from "@/env";
export default {
  name: "homePage",
  data() {
    return {
      config: null,
    };
  },
  created() {
    this.config = configFn(0);
  },
};
</script>
<style lang="scss" scoped>
.banner {
  img {
    width: 100%;
  }
}
.difficulty {
  
    position: fixed;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    background-color: #e4181b;

img {
    width: 100%;
}
}
.path {
  width: 100%;
  background-color: rgb(250, 249, 249);
  padding-bottom: 50px;
}
.title {
  font-size: 40px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
  line-height: 48px;
  text-align: center;
  padding: 40px 0 20px;
}
.content {
  width: 90%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: flex-start;
  .item {
    width: 20%;
  }
}
.chart {
  width: 100%;
  //   height: 204px;
}
.name {
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
  line-height: 33px;
  margin: 12px 0 4px;
}
.info {
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 25px;
}
@media screen and (max-width: 900px) {
  .name {
    font-size: 18px;
  }
  .info {
    font-size: 14px;
    line-height: 20px;
  }
}
@media screen and (max-width: 700px) {
  .content {
    flex-wrap: wrap;
    .item {
      width: 40%;
    }
  }
  .title {
    font-size: 30px;
  }
  .name {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 26px;
    margin: 12px 0 4px;
  }
  .info {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 16px;
  }
}

@media screen and (max-width: 420px) {
  .title {
    font-size: 26px;
  }

  .content {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    .item {
      width: 70%;
      margin-bottom: 10px;
    }
  }
}

@media screen and (max-width: 300px) {
  .title {
    font-size: 22px;
  }
}
</style>
